import { plainToInstance } from "class-transformer";
import { PropsWithChildren, useState } from "react";
import { useNavigate } from "react-router-dom";

import MemberInfo from "../../models/MemberInfo";
import TimeUtil from "../../utils/TimeUtil";
import MemberContext from "./MemberContext";

const getMember = () => {
    if (navigator.userAgent.match(/(iPhone|iPod|iPad|Android)/)) {
        const jsonString = localStorage.getItem("member");
        if (jsonString) {
            return plainToInstance(
                MemberInfo,
                JSON.parse(jsonString) as MemberInfo
            );
        }
    } else {
        const jsonString = localStorage.getItem("member");
        if (jsonString) {
            return plainToInstance(
                MemberInfo,
                JSON.parse(jsonString) as MemberInfo
            );
        }
    }
};

const MemberContextProvider = ({ children }: PropsWithChildren) => {
    const navigate = useNavigate();
    const [member, setMember] = useState<MemberInfo | undefined>(getMember());
    const getMemInfo = (target: MemberInfo) => {
        if (navigator.userAgent.match(/(iPhone|iPod|iPad|Android)/)) {
            localStorage.setItem("member", JSON.stringify(target));
            setMember(target);
        } else {
            localStorage.setItem("member", JSON.stringify(target));
            setMember(target);
        }
    };
    const selectLocation = () => {
        if (navigator.userAgent.match(/(iPhone|iPod|iPad|Android)/)) {
            setMember(
                JSON.parse(
                    localStorage.getItem("member") as string
                ) as MemberInfo
            );
            navigate("/");
        } else {
            setMember(
                JSON.parse(
                    localStorage.getItem("member") as string
                ) as MemberInfo
            );
            navigate("/");
        }
    };
    const logout = async () => {
        if (navigator.userAgent.match(/(iPhone|iPod|iPad|Android)/)) {
            setMember(undefined);
            localStorage.removeItem("member");
            await TimeUtil.delay(10);
            navigate("/");
        } else {
            setMember(undefined);
            localStorage.removeItem("member");
            sessionStorage.removeItem("member");
            await TimeUtil.delay(10);
            navigate("/");
        }
    };
    const debugLogin = (member: MemberInfo) => {
        if (navigator.userAgent.match(/(iPhone|iPod|iPad|Android)/)) {
            setMember(member);
            localStorage.setItem("member", JSON.stringify(member));
        } else {
            setMember(member);
            localStorage.setItem("member", JSON.stringify(member));
        }
    };
    return (
        <MemberContext.Provider
            value={{
                member,
                logout,
                debugLogin,
                selectLocation,
                setMember,
                getMemInfo,
            }}
        >
            {children}
        </MemberContext.Provider>
    );
};

export default MemberContextProvider;
